import { isEmpty, filter, keyBy } from "lodash";

type TagTypeConfigEntry = {
  id: string;
  isReadonly?: boolean;
};

export const filterTagTypes = ({
  tagTypesConfig,
  tagTypes,
}: {
  tagTypesConfig?: TagTypeConfigEntry[] | null;
  tagTypes?: string[];
}): string[] | undefined => {
  if (isEmpty(tagTypesConfig)) {
    return tagTypes;
  }
  const tagTypeConfigKeyMap = keyBy(tagTypesConfig, "id");
  return filter(tagTypes, (typeId) => {
    if (!tagTypeConfigKeyMap[typeId]?.isReadonly) {
      return true;
    }
    return false;
  });
};
